import Vue from "vue";
import Router from "vue-router";
import Home from "./page/Home.vue";
import BigScreen from "./page/bigScreen.vue";
import ServiceIntelligenceIndex from "./page/serviceIntelligence/index.vue";
import IntelligentService from "./page/serviceIntelligence/intelligentService.vue";
import CustomerRecommend from "./page/serviceIntelligence/customerRecommend.vue";
import achievementTrading from "./page/achievementTrading/index.vue";
import ContentIndex from "./page/content/index.vue";
import HotImg from "./page/content/hotImg.vue";
import SystemNotice from "./page/content/systemNotice.vue";
import News from "./page/content/news.vue";
import bigEvents from "./page/content/bigEvents.vue";
import TechnologyCase from "./page/content/technology_case.vue";
import PolicyServices from "./page/content/policyServices.vue";
import serviceInnovateIndex from "./page/serviceInnovate/index.vue";
import Exhibition from "./page/serviceInnovate/exhibition.vue";
import OnLineLive from "./page/serviceInnovate/onLineLive.vue";
import OnLineVideo from "./page/serviceInnovate/onLineVideo.vue";
import InnerFiled from "./page/serviceInnovate/innerFiled.vue";
import Active from "./page/serviceInnovate/active.vue";
import ActiveDetail from "./page/serviceInnovate/activeDetail.vue";
import Appointment from "./page/serviceInnovate/appointment.vue";
import finaceIndex from "./page/finance/index.vue";
import Field from "./page/serviceInnovate/field.vue";
import errorPage from "./page/error/errorPage.vue";
import uersIndex from "./page/user/index.vue";
import affirm from "./page/user/affirm.vue";
import accountManage from "./page/user/accountManage.vue";
import examineRole from "./page/user/examineRole.vue";
import roleManage from "./page/user/roleManage.vue";
import friendLink from "./page/content/friend-link.vue";
import floatComponent from "./page/content/float.vue";
import fastService from "./page/servicePreview/fastService.vue";
import servicePreviewIndex from "./page/servicePreview/index.vue";
import MessageBox from "./page/servicePreview/message.vue";
import Transfer from "./page/transfer/index.vue";
import tracking from "./page/transfer/tracking.vue";
import trade from "./page/transfer/trade.vue";
import business from "./page/transfer/business.vue";
import person from "./page/transfer/person.vue";
import consultant from "./page/transfer/consultant.vue";
import expertsManage from "./page/transfer/expertsManage.vue";

import photo from "./page/transfer/photo.vue";
import classes from "./page/transfer/classes.vue";
import slide from "./page/transfer/slide.vue";
import wisdom from "./page/transfer/wisdom.vue";
import transform from "./page/resourcesIT/transform.vue";
import enterprises from "./page/resourcesIT/enterprises.vue";
import research from "./page/resourcesIT/research.vue";
import laboratory from "./page/resourcesIT/laboratory.vue";
import researchCenter from "./page/resourcesIT/researchCenter.vue";
import institute from "./page/resourcesIT/institute.vue";
import base from "./page/resourcesIT/base.vue";
import demonstration from "./page/resourcesIT/demonstration.vue";
import announces from "./page/announce/index.vue";
import announce from "./page/announce/announce.vue";
import integration from "./page/integration/index.vue";
import Inews from "./page/integration/news.vue";
import Igain from "./page/integration/gain.vue";
import Ineed from "./page/integration/need.vue";
import Ipolicy from "./page/integration/policy/policy.vue";
import industry from "./page/integration/industry.vue";
import IntelligentEvaluation from "./page/serviceIntelligence/intelligentEvaluation.vue";
import meeting from "./page/meeting/index.vue";
/* 大屏信息维护 */
import largeScreenInformation from "./page/largeScreenInformation/index.vue";
Vue.use(Router);
const YhRouter = new Router({
  base: "lanzhou_technology_market_manage",
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
    },
    {
      path: "/home",
      name: "home",
      component: Home,
    },
    /** 数据大屏 */
    {
      path: "/bigScreen",
      name: "bigScreen",
      component: BigScreen,
    },
    //消息中心
    {
      path: "/news",
      name: "news",
      component: () => import("./page/news/index"),
    },
    /************************************* 军民融合 开始 ↓ *************************************/
    {
      path: "/civil",
      name: "civil",
      component: integration,
      children: [
        {
          path: "/civil/news",
          name: "cnews",
          component: Inews,
        },
        {
          path: "/civil/gain",
          name: "cgain",
          component: Igain,
        },
        {
          path: "/civil/need",
          name: "cneed",
          component: Ineed,
        },
        {
          path: "/civil/policy",
          name: "cpolicy",
          component: Ipolicy,
        },
        {
          path: "/civil/industry",
          name: "cindustry",
          component: industry,
        },
      ],
    },
    /************************************* 智能服务 开始 ↓ *************************************/
    {
      path: "/serviceIntelligence",
      name: "serviceIntelligence",
      component: ServiceIntelligenceIndex,
      children: [
        /** 智能评价 */
        {
          path: "/serviceIntelligence/intelligentEvaluation",
          name: "intelligentEvaluation",
          component: IntelligentEvaluation,
        },
        /** 智能服务 - 智能咨询 / 在线客服机器人 */
        {
          path: "/serviceIntelligence/intelligentService",
          name: "intelligentService",
          component: IntelligentService,
        },
        /** 智能服务 - 智能推荐 */
        {
          path: "/serviceIntelligence/customerRecommend",
          name: "customerRecommend",
          component: CustomerRecommend,
        },
        {
          path: "/serviceIntelligence/keyword",
          name: "keyword",
          component: () => import("./page/serviceIntelligence/keyword.vue"),
        },
      ],
    },
    /************************************* 智能服务 结束 ↑ *************************************/

    /*************************************  创新劵 开始 ↓ *************************************/

    // {
    //   path: '/innovationVoucher',
    //   name: 'innovationVoucher',
    //   component: innovationVoucher,
    //   children: []
    // },

    /************************************* 创新劵 结束 ↑ *************************************/
    /************************************* 金融服务 开始 ↓ *************************************/
    {
      path: "/finance",
      name: "finance",
      component: finaceIndex,
      redirect: "/finance/guarantee",
      children: [
        /** 担保-担保需求 */
        {
          path: "/finance/warrant",
          name: "warrant",
          component: () => import("./page/finance/warrant/index.vue"),
        },
        /** 大市场-特色服务 */
        {
          path: "/finance/specialServive",
          name: "guarantee",
          component: () => import("./page/finance/specialServive/index.vue"),
        },
        /** 担保-机构简介 */
        {
          path: "/finance/mechanism",
          name: "mechanism",
          component: () => import("./page/finance/mechanism"),
        },
        /** 投资机构--投资需求 */
        {
          path: "/finance/invest",
          name: "invest",
          component: () => import("./page/finance/invest/index.vue"),
        },
        /** 投资-机构简介 */
        {
          path: "/finance/investMechanism",
          name: "investMechanism",
          component: () => import("./page/finance/investMechanism"),
        },
        /** 金融--金融产品 */
        {
          path: "/finance/financeProduct",
          name: "financeProduct",
          component: () => import("./page/finance/financeProduct"),
        },
        /** 金融--审批--融资需求 */
        {
          path: "/finance/financeDemand",
          name: "financeDemand",
          component: () => import("./page/finance/financeDemand"),
        },
        /** 金融-机构简介 */
        {
          path: "/finance/guarantee",
          name: "guarantee",
          component: () => import("./page/finance/guarantee"),
        },
        /** 金融-金融服务 */
        {
          path: "/finance/service",
          name: "service",
          component: () => import("./page/finance/service/index.vue"),
        },
      ],
    },
    /************************************* 金融服务 结束 ↑ *************************************/
    /************************************* 成果交易平台 开始 ↓ *************************************/
    {
      path: "/achievementTrading",
      name: "achievementTrading",
      component: achievementTrading,
      children: [
        /** 科技成果 */
        {
          path: "/achievementTrading/achievementFinance",
          name: "achievementFinance",
          component: () => import("./page/transfer/achievement.vue"),
        },
        /** 预约管理 - 场地/服务预约 */
        {
          path: "/achievementTrading/appointmentFinance",
          name: "appointment",
          component: Appointment,
        },
        {
          path: "/achievementTrading/businessFinance",
          name: "businessFinance",
          component: business,
        },
        /** 场地管理 */
        {
          path: "/achievementTrading/fieldFinance",
          name: "/serviceInnovate/appointment",
          component: Field,
        },
        {
          path: "/achievementTrading/active/:id",
          name: "active",
          component: ActiveDetail,
        },
        {
          path: "/achievementTrading/active/:id",
          name: "active",
          component: ActiveDetail,
        },
        {
          path: "/achievementTrading/business/experts",
          name: "experts",
          component: () => import("./page/transfer/experts.vue"),
        },
        {
          path: "/achievementTrading/business/classes",
          name: "classes",
          component: classes,
        },
        {
          path: "/achievementTrading/business/person",
          name: "person",
          component: person,
        },
        {
          path: "/achievementTrading/business/consultant",
          name: "consultant",
          component: consultant,
        },
        {
          path: "/achievementTrading/business/expertsManage",
          name: "expertsManage",
          component: expertsManage,
        },
        /** 信息服务-信息咨询 */
        {
          path: "/achievementTrading/technology/caseFinance",
          name: "technology",
          component: TechnologyCase,
        },
        /** 成果交易平台-竞价拍卖 */
        {
          path: "/achievementTrading/competitiveAuctionFinance",
          name: "competitiveAuction",
          component: () =>
            import("./page/achievementTrading/competitiveAuction/index.vue"),
        },
        /** 科技需求 */
        {
          path: "/achievementTrading/demandFinance",
          name: "demand",
          component: () => import("./page/transfer/demand.vue"),
        },
        {
          path: "/achievementTrading/tradeFinance",
          name: "trade",
          component: trade,
        },
        /** 展会管理 - 展会管理 */
        {
          path: "/achievementTrading/exhibitionFinance",
          name: "exhibitionFinance",
          component: Exhibition,
        },
        /** 视频模块 */
        {
          path: "/achievementTrading/onLineVideoFinance",
          name: "onLineVideoFinance",
          component: OnLineVideo,
        },
        /** 会议发布 */
        {
          path: "/meeting/index",
          name: "meetingPush",
          component: meeting,
        },
        /** 活动/会议管理 */
        {
          path: "/achievementTrading/activeFinance",
          name: "active",
          component: Active,
        },
        /** 成果交易平台-挂牌交易 */
        {
          path: "/achievementTrading/listingTrading",
          name: "listingTrading",
          component: () =>
            import("./page/achievementTrading/listingTrading/index.vue"),
        },
        /** 成果交易平台-挂牌交易 */
        {
          path: "/achievementTrading/listingTradingFinance",
          name: "listingTrading",
          component: () =>
            import("./page/achievementTrading/listingTrading/index.vue"),
        },
        /** 成果交易平台-竞价拍卖 */
        {
          path: "/achievementTrading/competitiveAuction",
          name: "competitiveAuction",
          component: () =>
            import("./page/achievementTrading/competitiveAuction/index.vue"),
        },
        /** 成果交易平台-对接沙龙 */
        {
          path: "/achievementTrading/dockingSalon",
          name: "dockingSalon",
          component: () => import("./page/achievementTrading/dockingSalon"),
        },
        /** 成果交易平台-对接沙龙 */
        {
          path: "/achievementTrading/dockingSalonFinance",
          name: "dockingSalon",
          component: () =>
            import("./page/achievementTrading/dockingSalon/index.vue"),
        },
        /** 成果交易平台-对接沙龙 */
        {
          path: "/achievementTrading/dockingSalonFinance",
          name: "dockingSalon",
          component: () =>
            import("./page/achievementTrading/dockingSalon/index.vue"),
        },
        /** 成果交易平台-轮播图设置 */
        {
          path: "/achievementTrading/rotationChart",
          name: "rotationChart",
          component: () => import("./page/achievementTrading/rotationChart"),
        },
        /** 成果交易平台-轮播图设置 */
        {
          path: "/achievementTrading/rotationChartFinance",
          name: "rotationChart",
          component: () =>
            import("./page/achievementTrading/rotationChart/index.vue"),
        },
        /** 成果交易平台-轮播图设置 */
        {
          path: "/achievementTrading/rotationChartFinance",
          name: "rotationChart",
          component: () =>
            import("./page/achievementTrading/rotationChart/index.vue"),
        },
        /** 成果交易平台-合作机构 */
        {
          path: "/achievementTrading/collaborateOrganization",
          name: "collaborateOrganization",
          component: () =>
            import("./page/achievementTrading/collaborateOrganization"),
        },
        /** 成果交易平台-合作机构 */
        {
          path: "/achievementTrading/collaborateOrganizationFinance",
          name: "collaborateOrganization",
          component: () =>
            import("./page/achievementTrading/collaborateOrganization"),
        },
        {
          path: "/achievementTrading/talents",
          name: "talents",
          component: () => import("./page/transfer/talents/index.vue"),
        },
        {
          path: "/achievementTrading/platform",
          name: "platform",
          component: () => import("./page/transfer/platform/index.vue"),
        },
      ],
    },
    /* 大屏信息维护 */
    {
      path: "/largeScreenInformation",
      name: "largeScreenInformation",
      component: largeScreenInformation,
      children: [
        //科技市场
        {
          path: "/TechnologyMarket/index",
          name: "TechnologyMarket",
          component: () => import("./page/largeScreenInformation/TechnologyMarket/index.vue"),
        },
        //党建
        {
          path: "/PartyBbuilding/index",
          name: "PartyBbuilding",
          component: () => import("./page/largeScreenInformation/PartyBbuilding/index.vue"),
        },
        //服务机构
        {
          path: "/ServiceAgency/index",
          name: "ServiceAgency",
          component: () => import("./page/largeScreenInformation/ServiceAgency/index.vue"),
        },
        //技术交易
        {
          path: "/TechnologyTrading/index",
          name: "TechnologyTrading",
          component: () => import("./page/largeScreenInformation/TechnologyTrading/index.vue"),
        },
        //技术转移
        {
          path: "/TechnologyTransfer/index",
          name: "TechnologyTransfer",
          component: () => import("./page/largeScreenInformation/TechnologyTransfer/index.vue"),
        },
        //科技创新券
        {
          path: "/TechnologicalInnovation/index",
          name: "TechnologicalInnovation",
          component: () => import("./page/largeScreenInformation/TechnologicalInnovation/index.vue"),
        },
        //军民融合
        {
          path: "/MilitaryCivilianIntegration/index",
          name: "MilitaryCivilianIntegration",
          component: () => import("./page/largeScreenInformation/MilitaryCivilianIntegration/index.vue"),
        },
        //创客创业
        {
          path: "/MakerEntrepreneurship/index",
          name: "MakerEntrepreneurship",
          component: () => import("./page/largeScreenInformation/MakerEntrepreneurship/index.vue"),
        },
        //科技金融
        {
          path: "/TechnologyFinance/index",
          name: "TechnologyFinance",
          component: () => import("./page/largeScreenInformation/TechnologyFinance/index.vue"),
        },
        //人才培育
        {
          path: "/TalentCultivation/index",
          name: "TalentCultivation",
          component: () => import("./page/largeScreenInformation/TalentCultivation/index.vue"),
        },

      ],
    },
    /*  */
    {
      path: "/party",
      name: "party",
      component: () => import("./page/party/index.vue"),
    },

    /************************************* 成果交易平台 结束 ↑ *************************************/
    /************************************* 内容发布管理 开始 ↓ *************************************/
    {
      path: "/content",
      name: "content",
      component: ContentIndex,
      children: [
        /** 首页轮播图 */
        {
          path: "/content/hotImg",
          name: "hotImg",
          component: HotImg,
        },
        /** 首页系统公告 */
        {
          path: "/content/systemNotice",
          name: "systemNotice",
          component: SystemNotice,
        },
        /** 首页友情链接 */
        {
          path: "/content/friendLink",
          name: "friendLink",
          component: friendLink,
        },
        /** 首页浮窗广告 **/
        {
          path: "/content/float",
          name: "float",
          component: floatComponent,
        },
        /** 新闻动态 */
        {
          path: "/content/news",
          name: "news",
          component: News,
        },
        /** 大事记 */
        {
          path: "/content/bigEvents",
          name: "bigEvents",
          component: bigEvents,
        },

        /** 信息服务-信息咨询 */
        {
          path: "/content/technology/case",
          name: "technology",
          component: TechnologyCase,
        },
        /** 信息服务-资料下载 */
        {
          path: "/content/technology/data",
          name: "technology",
          component: () => import("./page/content/technology_data.vue"),
        },
        // /** 科技学院管理 - 案例管理 */
        // {
        //   path: "/content/technology_case",
        //   name: "technology_case",
        //   component: () => import("./page/content/technology_case.vue")
        // },
        // /** 科技学院管理 - 资料管理 */
        // {
        //   path: "/content/technology_data",
        //   name: "technology_data",
        //   component: () => import("./page/content/technology_data.vue")
        // },
        /** 政策服务 */
        {
          path: "/content/policyServices",
          name: "policyServices",
          component: PolicyServices,
        },
        /** 信息维护 */
        {
          path: "/content/infoMaintenance",
          name: "infoMaintenance",
          component: () => import("./page/content/infoMaintenance.vue"),
        },
        /** 我的印章 */
        {
          path: "/content/stamp",
          name: "stamp",
          component: () => import("./page/content/stamp"),
        },
      ],
    },
    /************************************* 内容管理 结束 ↑ *************************************/

    /************************************* 用户管理 开始 ↓ *************************************/
    {
      path: "/user",
      name: "user",
      component: uersIndex,
      children: [
        /** 账号管理 */
        {
          path: "/user/accountManage",
          name: "accountManage",
          component: accountManage,
        },
        /** 网站注册用户管理 */
        {
          path: "/user/examineRole",
          name: "examineRole",
          component: examineRole,
        },
        {
          path: "/user/affirm/:id",
          name: "affirm",
          component: affirm,
        },
        /** 角色管理 */
        {
          path: "/user/roleManage",
          name: "roleManage",
          component: roleManage,
        },
      ],
    },
    /************************************* 用户管理 结束 ↑ *************************************/

    /************************************* 科技资源 开始 ↓ *************************************/
    {
      path: "/resourcesIT",
      name: "resourcesIT",
      component: () => import("./page/resourcesIT/index.vue"),
      children: [
        // 推荐列表
        {
          path: "/resourcesIT/recommend",
          name: "recommend",
          component: () => import("./page/resourcesIT/recommend"),
        },
        // 资源库
        {
          path: "/resourcesIT/resourcePool",
          name: "resourcePool",
          component: () => import("./page/resourcesIT/resourcePool"),
        },
        // 科研仪器
        {
          path: "/resourcesIT/instrument",
          name: "instrument",
          component: () => import("./page/resourcesIT/instrument"),
        },
        // 双创载体
        {
          path: "/resourcesIT/incubate",
          name: "incubate",
          component: () => import("./page/resourcesIT/incubate/index"),
        },
        // 创业孵化平台
        {
          path: "/resourcesIT/hatch",
          name: "incubate",
          component: () => import("./page/resourcesIT/hatch/index"),
        },
        // 科研仪器
        {
          path: "/resourcesIT/settlement",
          name: "settlement",
          component: () => import("./page/resourcesIT/settlement"),
        },
        // 科技成果
        {
          path: "/resourcesIT/gain",
          name: "gain",
          component: () => import("./page/resourcesIT/gain.vue"),
        },
        /** 新型研发机构 */
        {
          path: "/resourcesIT/research",
          name: "research",
          component: research,
        },
        /** 重点实验室 */
        {
          path: "/resourcesIT/laboratory",
          name: "laboratory",
          component: laboratory,
        },
        /** 研究中心 */
        {
          path: "/resourcesIT/researchCenter",
          name: "researchCenter",
          component: researchCenter,
        },
        /** 产业研究院 */
        {
          path: "/resourcesIT/institute",
          name: "institute",
          component: institute,
        },
        /** 国际科技与合作基地 */
        {
          path: "/resourcesIT/base",
          name: "base",
          component: base,
        },
        /** 技术转移示范 */
        {
          path: "/resourcesIT/demonstration",
          name: "demonstration",
          component: demonstration,
        },
        /** 科技成果转化基地 */
        {
          path: "/resourcesIT/transform",
          name: "transform",
          component: transform,
        },
        /** 中小企业公共服务平台 */
        {
          path: "/resourcesIT/enterprises",
          name: "enterprises",
          component: enterprises,
        },
      ],
    },
    /************************************* 科技资源 结束 ↑ *************************************/

    /************************************* 服务创新管理 开始 ↓ *************************************/
    {
      path: "/serviceInnovate",
      name: "serviceInnovate",
      component: serviceInnovateIndex,
      children: [
        // /** 智能服务 - 智能咨询 */
        // {
        //   path: "/serviceInnovate/intelligentService",
        //   name: "intelligentService",
        //   component: () => import("./page/serviceInnovate/intelligentService.vue")
        // },
        /** 展会管理 - 展会管理 */
        {
          path: "/serviceInnovate/exhibition",
          name: "exhibition",
          component: Exhibition,
        },
        /** 展会管理 - 展品 */
        {
          path: "/serviceInnovate/exhibition/:id",
          name: "exhibition",
          component: () =>
            import("./page/serviceInnovate/exhibition_release.vue"),
        },
        // /** 展会管理 - 参展审核 */
        // {
        //   path: "/serviceInnovate/exhibition_examine",
        //   name: "exhibition_examine",
        //   component: () => import("./page/serviceInnovate/exhibition_examine.vue")
        // },
        /** 在线直播 */
        {
          path: "/serviceInnovate/onLineLive",
          name: "onLineLive",
          component: OnLineLive,
        },
        /** 视频模块 */
        {
          path: "/serviceInnovate/onLineVideo",
          name: "onLineVideo",
          component: OnLineVideo,
        },
        /* 内部会议管理 */
        {
          path: "/serviceInnovate/innerFiled",
          name: "innerFiled",
          component: InnerFiled,
        },
        /** 活动/会议管理 */
        {
          path: "/serviceInnovate/active",
          name: "active",
          component: Active,
        },
        {
          path: "/serviceInnovate/active/:id",
          name: "active",
          component: ActiveDetail,
        },

        /** 预约管理 - 场地/服务预约 */
        {
          path: "/serviceInnovate/appointment",
          name: "appointment",
          component: Appointment,
        },
        /** 场地管理 */
        {
          path: "/serviceInnovate/field",
          name: "field",
          component: Field,
        },
        // /** 预约管理 - 服务预约 */
        // {
        //   path: "/serviceInnovate/appointment_service",
        //   name: "appointment_service",
        //   component: () => import("./page/serviceInnovate/appointment_service.vue")
        // },
      ],
    },
    /************************************* 服务创新管理 结束 ↑ *************************************/

    /************************************* 服务预约 开始 ↑ *************************************/
    {
      path: "/servicePreview",
      name: "servicePreview",
      component: servicePreviewIndex,
      children: [
        /** 快速服务信息收集 */
        {
          path: "/servicePreview/fastService",
          name: "fastService",
          component: fastService,
        },
        /* 站内信息*/
        {
          path: "/servicePreview/message",
          name: "message",
          component: MessageBox,
        },
      ],
    },
    /************************************* 服务预约 结束 ↑ *************************************/
    /************************************* 控制台 开始 ↑ *************************************/
    {
      path: "/announce/announce",
      name: "announce",
      component: announces,
      children: [
        /* 站内信息*/
        {
          path: "/announce/announce",
          name: "announce",
          component: announce,
        },
      ],
    },
    /************************************* 控制台 结束 ↑ *************************************/

    /************************************* 科技服务管理 开始 ↓ *************************************/
    /** 科技服务管理 */
    // {
    //     path: "/serviceIT",
    //     name: "serviceIT",
    //     component: () => import("./page/serviceIT/index.vue"),
    //     children: [
    //         /** 转移转化 */
    //         {
    //             path: "/serviceIT/transfer",
    //             name: "transfer",
    //             component: () => import("./page/serviceIT/transfer.vue")
    //         },
    //         /** 知识产权 - 知识产权信息管理 */
    //         {
    //             path: "/serviceIT/intellectualProperty",
    //             name: "intellectualProperty",
    //             component: () => import("./page/serviceIT/intellectualProperty.vue")
    //         },
    //         /** 知识产权 - 产权价值评估管理 */
    //         {
    //             path: "/serviceIT/intellectualProperty_assess",
    //             name: "intellectualProperty_assess",
    //             component: () =>
    //     import("./page/serviceIT/intellectualProperty_assess.vue")
    //         },
    //         /** 中介服务管理 - 中介信息审核 */
    //         {
    //             path: "/serviceIT/intermediary",
    //             name: "intermediary",
    //             component: () => import("./page/serviceIT/intermediary.vue")
    //         }
    //     ]
    // },
    /************************************* 科技服务管理 结束 ↑ *************************************/

    /************************************* 转移转化 开始 ↓ *************************************/
    {
      path: "/transfer",
      name: "transfer",
      component: Transfer,
      children: [
        /** 科技成果 */
        {
          path: "/transfer/achievement",
          name: "achievement",
          component: () => import("./page/transfer/achievement.vue"),
        },
        /** 科技需求 */
        {
          path: "/transfer/demand",
          name: "demand",
          component: () => import("./page/transfer/demand.vue"),
        },
        {
          path: "/transfer/tracking",
          name: "tracking",
          component: tracking,
        },
        {
          path: "/transfer/trade",
          name: "trade",
          component: trade,
        },
        {
          path: "/transfer/business",
          name: "business",
          component: business,
        },
        {
          path: "/transfer/business/person",
          name: "person",
          component: person,
        },
        {
          path: "/transfer/business/consultant",
          name: "consultant",
          component: consultant,
        },
        {
          path: "/transfer/business/photo",
          name: "photo",
          component: photo,
        },
        {
          path: "/transfer/business/classes",
          name: "classes",
          component: classes,
        },
        {
          path: "/transfer/business/experts",
          name: "experts",
          component: () => import("./page/transfer/experts.vue"),
        },
        {
          path: "/transfer/slide",
          name: "slide",
          component: slide,
        },
        {
          path: "/transfer/wisdom",
          name: "wisdom",
          component: wisdom,
        },
        {
          path: "/transfer/keyWords",
          name: "keyWords",
          component: () => import("../src/page/transfer/keyWords"),
        },
      ],
    },
    /************************************* 转移转化 结束 ↑ *************************************/

    /************************************* 统计分析管理 开始 ↓ *************************************/
    /** 统计分析 */
    {
      path: "/statistical",
      name: "statistical",
      component: () => import("./page/statistical/index.vue"),
      children: [
        /** 活动统计 */
        {
          path: "/statistical/statistical_active",
          name: "statistical_active",
          component: () => import("./page/statistical/statistical_active.vue"),
        },
        /** 其他统计 */
        {
          path: "/statistical/statistical_other",
          name: "statistical_other",
          component: () => import("./page/statistical/statistical_other"),
        },
      ],
    },
    /* *************************************科技创新券****************************** */
    {
      path: "/innovation",
      name: "innovation",
      component: () => import("./page/innovation/index.vue"),
      children: [
        /** 创新券发放 */
        {
          path: "/innovation/coupon_send",
          name: "coupon_send",
          component: () => import("./page/innovation/coupon_send"),
        },
        /** 创新券使用 */
        {
          path: "/innovation/coupon_use",
          name: "coupon_use",
          component: () => import("./page/innovation/coupon_use"),
        },
        /** 创新券服务 */
        {
          path: "/innovation/coupon_service",
          name: "coupon_service",
          component: () => import("./page/innovation/coupon_service"),
        },
        /** 创新券批次统计数据 */
        {
          path: "/innovation/coupon_data",
          name: "coupon_data",
          component: () => import("./page/innovation/coupon_data"),
        },
        /** 收劵机构-机构简介 */
        {
          path: "/innovation/institutionProfile",
          name: "institutionProfile",
          component: () =>
            import("./page/innovation/institutionProfile/index.vue"),
        },
        /** 收劵机构-仪器服务 */
        {
          path: "/innovation/instrument",
          name: "instrument",
          component: () => import("./page/innovation/instrument/index.vue"),
        },
        /** 收劵机构-审批管理 */
        {
          path: "/innovation/approvalManagement",
          name: "approvalManagement",
          component: () =>
            import("./page/innovation/approvalManagement/index.vue"),
        },
        /** 收劵机构-服务成果库 */
        {
          path: "/innovation/serviceResults",
          name: "serviceResults",
          component: () => import("./page/innovation/serviceResults/index.vue"),
        },
        /** 服务管理机构-收劵机构 */
        {
          path: "/innovation/collectingInstitutions",
          name: "collectingInstitutions",
          component: () =>
            import("./page/innovation/collectingInstitutions/index.vue"),
        },
        /** 服务管理机构-审批管理 */
        {
          path: "/innovation/collectingApproval",
          name: "collectingApproval",
          component: () =>
            import("./page/innovation/collectingApproval/index.vue"),
        },
        /** 服务管理机构-通知公告 */
        {
          path: "/innovation/collectingNotification",
          name: "collectingNotification",
          component: () =>
            import("./page/innovation/collectingNotification/index.vue"),
        },
      ],
    },
    /************************************* 统计分析管理 结束 ↑ *************************************/
    /** 关于我们 */
    // {
    //     path: "/about",
    //     name: "about",
    //     // route level code-splitting
    //     // this generates a separate chunk (about.[hash].js) for this route
    //     // which is lazy-loaded when the route is visited.
    //     component: () => import(/* webpackChunkName: "about" */ "./page/About.vue")
    // },
    /** 人工客服 */
    {
      path: "/customerService",
      name: "customerService",
      component: () => import("./page/customerService.vue"),
    },
    { path: "/error", name: "error", component: errorPage },
    {
      path: "*", // 页面不存在的情况下会跳到404页面
      redirect: "/error",
      name: "notFound",
    },
    {
      path: "/login", // 页面不存在的情况下会跳到404页面
      name: "login",
      component: () => import("./page/login.vue"),
    },
  ],
});
// YhRouter.beforeEach((to, from, next) => {
//   // ...
//   // if (/(customerService)/.test(to.fullPath)) {
//   //   setTimeout(() => {
//   //     next({path:from.fullPath});
//   //   }, 1000);
//   // }
// });
export default YhRouter;
